var map = {
	"./admin.js": 1742,
	"./auth.js": 3547,
	"./check-auth.js": 568,
	"./guest.js": 4517,
	"./locale.js": 6991,
	"./patient.js": 9540,
	"./staff.js": 875,
	"./unblinded.js": 4558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1991;